import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import { DEVICE_STATE_LABEL, DEVICE_STATE_TONE, DeviceState } from '../../Enums/device-state.enum';
import { LICENCE_STATE_LABEL } from '../../Enums/licence-state.enum';
import {
  DeviceLicenceResponse,
  DeviceResponse,
} from '../../Interfaces/api/backoffice/device.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class Device {
  id = '';
  name: string | null = null;
  azureADDeviceId: string | null = null;
  organization_id: string | null = null;
  last_seen_at: string | null = null;
  inactivity_reference: string | null = null;
  state = '';
  is_inactive = false;
  is_provisioned = false;
  created_at: string | null = null;
  deleted_at: string | null = null;
  licence: DeviceLicenceResponse | null = null;

  constructor(data: Partial<DeviceResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.name || this.azureADDeviceId || this.id;
  }

  get stateLabelKey(): string {
    return DEVICE_STATE_LABEL[this.state] ?? this.state;
  }

  get stateTone(): StatusTone {
    return DEVICE_STATE_TONE[this.state] ?? 'neutral';
  }

  get isRetired(): boolean {
    return this.state === DeviceState.RETIRED;
  }

  get hasNeverCheckedIn(): boolean {
    return this.last_seen_at === null;
  }

  get licenceStateLabelKey(): string {
    const state = this.licence?.state;

    return state ? (LICENCE_STATE_LABEL[state] ?? state) : VALUE_UNRESOLVED;
  }
}
